import React from 'react';
import Card from 'react-bootstrap/Card';
import { IntlMessageValue, MIcon } from "../../../../../@WUM/core/Elements";
import CheckPermissions from "../../../../../@WUM/core/Function/Permissions/CheckPermissions";
import {CryptDecrypt} from "../../../../../@WUM/core/Elements/crypt/Crypt";

export interface WelcomeFirstStepsRightProps {
    Store: any;
    navigate: (to: string) => void;
}

type ChipVariant = 'default' | 'primary' | 'info' | 'success';

interface ChipProps {
    icon: string;
    label: string;

    variant?: ChipVariant;

    /**
     * If true, renders ONLY the icon (no pill/chip wrapper, no label).
     * Useful for separators like arrows between chips.
     */
    iconOnly?: boolean;

    /**
     * Optional aria-label for iconOnly chips.
     * If not provided, label is used.
     */
    ariaLabel?: string;


    /**
     * Optional link
     */
    link?: string

    navigate?: (to: string) => void;

    permission?: boolean
}

const chipStyles: Record<ChipVariant, React.CSSProperties> = {
    default: { background: '#f6f8fb', borderColor: '#e7edf5', color: '#1f2a37' },
    primary: { background: '#f6f8fb', borderColor: '#e7edf5', color: '#1f2a37' },
    info: { background: '#f6f8fb', borderColor: '#e7edf5', color: '#1f2a37' },
    success: { background: '#f6f8fb', borderColor: '#e7edf5', color: '#1f2a37' },
};

const Chip: React.FC<ChipProps> = ({
                                       icon,
                                       label,
                                       variant = 'default',
                                       iconOnly = false,
                                       ariaLabel,
                                        link,
                                        navigate,
                                        permission,
                                   }) => {
    if (iconOnly) {
        return (
            <span
                className="d-inline-flex align-items-center justify-content-center"
                role="img"
                aria-label={ariaLabel ?? label}
                style={{
                    padding: '0 2px',
                    color: '#6b7280',
                    lineHeight: '16px',
                }}
            >
        <MIcon newMaterial variant="-outlined" style={{ fontSize: 16, lineHeight: '16px' }}>
          {icon}
        </MIcon>
      </span>
        );
    }

    const isClickable = Boolean(link && navigate);

    const handleClick = (): void => {

        if (!link || !navigate) {
            return;
        }

        if (permission === false) {
            navigate("/moduleNotePurchased")
            return;
        }



        navigate(link);
    };

    return (
        <button
            type="button"
            className="d-inline-flex align-items-center gap-2"
            style={{
                border: '1px solid',
                borderRadius: 999,
                padding: '6px 12px',
                fontSize: 12,
                lineHeight: '14px',
                cursor: 'pointer',
                ...chipStyles[variant],
            }}
            onClick={isClickable ? handleClick : undefined}
            disabled={!isClickable}
        >
            <MIcon newMaterial variant="-outlined" style={{ fontSize: 16, lineHeight: '16px', color: '#6bb5e2' }}>
                {icon}
            </MIcon>
            <span>{label}</span>
        </button>
    );
};

interface StepCardProps {
    icon: string;
    iconBg: string;
    iconColor: string;

    title: string;
    text: string;

    chips: ChipProps[];

    navigate?: (to: string) => void;

    permission?: boolean
}

const StepCard: React.FC<StepCardProps> = ({ icon, iconBg, iconColor, title, text, chips, navigate }) => {
    return (
        <div
            style={{
                border: '1px solid #e7edf5',
                borderRadius: 12,
                padding: 14,
                background: '#ffffff',
            }}
        >
            <div className="d-flex gap-3">
                <div
                    className="d-inline-flex align-items-center justify-content-center"
                    style={{
                        width: 38,
                        height: 38,
                        borderRadius: 10,
                        background: iconBg,
                        color: iconColor,
                        flex: '0 0 auto',
                    }}
                >
                    <MIcon newMaterial variant="-outlined" style={{ fontSize: 20, lineHeight: '20px' }}>
                        {icon}
                    </MIcon>
                </div>

                <div className="flex-grow-1">
                    <div style={{ fontWeight: 700, fontSize: 13, color: '#111827' }}>{title}</div>
                    <div style={{ marginTop: 4, fontSize: 12, color: '#6b7280' }}>{text}</div>

                    <div className="d-flex flex-wrap align-items-center gap-2" style={{ marginTop: 10 }}>
                        {chips.map((chip, index) => (
                            <Chip
                                key={`${chip.icon}-${chip.label}-${index}`}
                                icon={chip.icon}
                                label={chip.label}
                                variant={chip.variant}
                                iconOnly={chip.iconOnly}
                                ariaLabel={chip.ariaLabel}
                                link={chip.link}
                                navigate={navigate}
                                permission={chip.permission}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

const WelcomeFirstStepsRight: React.FC<WelcomeFirstStepsRightProps> = ({ Store, navigate }) => {

    if (localStorage.getItem('userRights') !== null && localStorage.getItem('userRights') !== undefined && JSON.parse(CryptDecrypt(localStorage.getItem('userRights') as string) as string).isMandant === false) {
        return (
            <>
                <Card
                    style={{
                        border: '1px solid #e7edf5',
                        borderRadius: 16,
                        background: '#ffffff',
                    }}
                >
                    <Card.Body style={{ padding: 18 }}>
                        <div style={{ marginBottom: 12 }}>
                            <div style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>
                                {IntlMessageValue('de', 'welcome.firstSteps.title', Store)}
                            </div>
                            <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                                {IntlMessageValue('de', 'welcome.firstSteps.subtitle', Store)}
                            </div>
                        </div>

                            <StepCard
                                icon="manage_accounts"
                                iconBg="#e6f7ff"
                                iconColor="#0891b2"
                                title={IntlMessageValue('de', 'welcome.firstSteps.step.user.title', Store)}
                                text={IntlMessageValue('de', 'welcome.firstSteps.step2.text', Store)}
                                navigate={navigate}
                                chips={[
                                    {
                                        icon: 'edit',
                                        label: IntlMessageValue('de', 'welcome.firstSteps.step2.action.editUser', Store),
                                        link: '/Member/Detail/' + Store.user.id
                                    },
                                ]}
                            />
                    </Card.Body>
                </Card>
            </>
        )
    }

    return (
        <Card
            style={{
                border: '1px solid #e7edf5',
                borderRadius: 16,
                background: '#ffffff',
            }}
        >
            <Card.Body style={{ padding: 18 }}>
                <div style={{ marginBottom: 12 }}>
                    <div style={{ fontWeight: 700, fontSize: 16, color: '#111827' }}>
                        {IntlMessageValue('de', 'welcome.firstSteps.title', Store)}
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280', marginTop: 2 }}>
                        {IntlMessageValue('de', 'welcome.firstSteps.subtitle', Store)}
                    </div>
                </div>

                <div className="d-flex flex-column" style={{ gap: 12 }}>
                    <StepCard
                        icon="apartment"
                        iconBg="#e7f0ff"
                        iconColor="#2563eb"
                        title={IntlMessageValue('de', 'welcome.firstSteps.step1.title', Store)}
                        text={IntlMessageValue('de', 'welcome.firstSteps.step1.text', Store)}
                        navigate={navigate}
                        chips={[
                            {
                                icon: 'domain',
                                label: IntlMessageValue('de', 'welcome.firstSteps.step1.action.company', Store),
                                link: "/company/overview/1"
                            },
                        ]}
                    />

                    <StepCard
                        icon="manage_accounts"
                        iconBg="#e6f7ff"
                        iconColor="#0891b2"
                        title={IntlMessageValue('de', 'welcome.firstSteps.step2.title', Store)}
                        text={IntlMessageValue('de', 'welcome.firstSteps.step2.text', Store)}
                        navigate={navigate}
                        chips={[
                            {
                                icon: 'group',
                                label: IntlMessageValue('de', 'welcome.firstSteps.step2.action.userManagement', Store),
                                link: '/Member/overview/1'
                            },
                            {
                                icon: 'edit',
                                label: IntlMessageValue('de', 'welcome.firstSteps.step2.action.editUser', Store),
                                link: '/Member/Detail/' + Store.user.id
                            },
                        ]}
                    />

                    <StepCard
                        icon="tune"
                        iconBg="#eafaf0"
                        iconColor="#16a34a"
                        title={IntlMessageValue('de', 'welcome.firstSteps.step3.title', Store)}
                        text={IntlMessageValue('de', 'welcome.firstSteps.step3.text', Store)}
                        navigate={navigate}
                        chips={[
                            {
                                icon: 'import_contacts',
                                label: IntlMessageValue('de', 'welcome.ticket.system', Store),
                                permission: CheckPermissions('Ticketsystem', ['Dashboard']),
                                link: "/generell/Settings/ticket"
                            },
                            {
                                icon: 'support',
                                label: IntlMessageValue('de', 'welcome.taskmanager.system', Store),
                                permission: CheckPermissions('TaskManager', ['Dashboard']),
                                link: "/cps/overview"
                            },
                            {
                                icon: 'hourglass_empty',
                                label: IntlMessageValue('de', 'welcome.worktimetracking.system', Store),
                                permission: CheckPermissions('Arbeitszeiterfassung', ['General_Settings_User']),
                                link: "/settings/worktime"
                            },
                        ]}
                    />

                    <div
                        style={{
                            borderRadius: 12,
                            padding: 12,
                            background: '#f7f8fb',
                            border: '1px solid #e7edf5',
                            fontSize: 12,
                            color: '#374151',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: IntlMessageValue('de', 'welcome.firstSteps.tip', Store),
                        }}
                    />
                </div>
            </Card.Body>
        </Card>
    );
};

export default WelcomeFirstStepsRight;
